import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "โปรโมชั่น", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayPromotions, (promotion, mindex) => {
        return (_openBlock(), _createElementBlock("div", { key: mindex }, [
          _createElementVNode("div", null, _toDisplayString(mindex + 1) + ". " + _toDisplayString(promotion.name), 1),
          _createElementVNode("div", null, " ( " + _toDisplayString(_ctx.datetimeFormat(new Date(promotion.startDate))) + " - " + _toDisplayString(_ctx.datetimeFormat(new Date(promotion.endDate))) + " ) ", 1)
        ]))
      }), 128))
    ])
  ]))
}